const StoragePropertiesToClear = [
  'id',
  'firstName',
  'lastName',
  'autoRedirected',
  'clientId',
  'phoneNumber',
  'preloadCampaigns',
  'createdAt',
  'email',
  'emailVerified',
  'activitiesTracked',
  'jobTitle',
  'accountSetUpCompletedAt',
  'companyName',
  'websiteUrl',
  'shopifyDomain',
  'streetAddress',
  'city',
  'state',
  'zipCode',
  'country',
  'timeZone',
  'businessRegion',
  'industry',
  'contactsDatabaseSize',
  'experienceLevel',
  'subscriptionStatus',
  'subscriptionTrialEndAt',
  'subscriptionPlanId',
  'subscriptionSmsCreditsQuantity',
  'subscriptionContactLimit',
  'hasClosedCompanyDetailsModal',
  'shouldRedirectOnSignIn',
  'onSignInRedirectTo',
  'oAuthClientCredentials'
];

/* eslint-disable no-undef */
export class VuexLocalStorage {
  #prefix: string;

  constructor(prefix: string) {
    this.#prefix = prefix;
  }

  get(propertyName: string): string | null | undefined {
    return localStorage.getItem(`${this.#prefix}_${propertyName}`);
  }

  set(
    state: any,
    payload: any,
    propertyName: string,
    isJsonObject = false
  ): void {
    const value = payload[propertyName] ?? '';
    state[propertyName] = value;
    const stringValue = isJsonObject ? JSON.stringify(value || null) : value;
    localStorage.setItem(`${this.#prefix}_${propertyName}`, stringValue);
  }

  clear(state: any): void {
    StoragePropertiesToClear.forEach(propertyName => {
      state[propertyName] = undefined;
      localStorage.removeItem(`${this.#prefix}_${propertyName}`);
    });
  }

  clearStorageOnly(): void {
    StoragePropertiesToClear.forEach(propertyName => {
      localStorage.removeItem(`${this.#prefix}_${propertyName}`);
    });
  }
}
